export default "__VITE_ASSET__BawuVg0G__"